import striptags from 'striptags';

var filterHtmlTags = function filterHtmlTags(str) {
  var allowed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['a', 'b', 'br', 'i', 'img', 'p'];
  var replacement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return Array.isArray(str) ? str.map(function (s) {
    return filterHtmlTags(s, allowed, replacement);
  }) : striptags(str, allowed, replacement);
};

export default filterHtmlTags;